import { useEffect, useState } from "react";
import { MultiSelectCustomProps, MultiSelectOption } from "./types";

export const useMultiSelect = ({
  data,
  initialValues,
  allValues,
  onChangeCallback,
}: MultiSelectCustomProps) => {
  const [displayValue, setDisplayValue] = useState<string>("");
  const [selectedItems, setSelectedItems] = useState<string[]>(
    data.length && initialValues.length === data.length
      ? [...initialValues, allValues.value]
      : initialValues
  );

  const filterUniqueItems = (items: string[], selectedOption: string): string[] => {
    return items.some((item) => item === selectedOption)
      ? items.filter((item) => item !== selectedOption)
      : [...items, selectedOption];
  };

  const handleClick = (option: MultiSelectOption) => {
    let newValue: string[] = [];

    if (option.value === allValues?.value) {
      newValue = selectedItems.includes(String(allValues.value)) ? [] : [allValues.value];
    } else {
      const validValues = filterUniqueItems(selectedItems, option.value).filter(
        (item) => item !== allValues?.value
      );

      newValue =
        data.length > 1 && validValues.length === data.length && allValues
          ? [allValues.value]
          : validValues;
    }

    setSelectedItems(newValue);
    onChangeCallback?.(
      data.filter((d) => newValue.includes(d.value)),
      option
    );
  };

  useEffect(() => {
    if ((allValues && selectedItems.includes(allValues.value)) || selectedItems.length === 0) {
      setDisplayValue(allValues.label);
      return;
    }

    setDisplayValue(
      data
        .filter((d) => selectedItems.includes(d.value))
        .map((a) => a.label)
        .join(", ")
    );
  }, [data, selectedItems, allValues]);

  return {
    displayValue,
    selectedItems,
    handleClick,
  };
};
